import { Clear, Save } from "@mui/icons-material";
import {
  Box,
  CircularProgress,
  Divider,
  Grid,
  IconButton,
  TextField,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import { masterAPI } from "../../../Masters/dataConfig";
import { axiosPrivate } from "../../../../axios/axios";
import { color } from "../../../../StyleData/Config";
import { toast } from "react-toastify";
import * as Yup from "yup";
import ErrorProps from "../../../../Component/Errorprops";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DemoItem } from "@mui/x-date-pickers/internals/demo";
import {
  fromUTC,
  getCurrentInTimeZone,
  getDateWithOutUTC,
  toUTCWithStartOf,
} from "../../../../utils/dateUtil";

const travelSchema = Yup.object({
  travelhours: Yup.string()
    .required("Time is required")
    .matches(/^\d+:[0-5]\d$/, "Format must be HH:MM and minutes 00-59"),
});

// Standalone Add/Edit popup for a single Travelling Time entry. Rendered as
// the content of a Dialog by the parent -- remounts fresh (via the Dialog's
// default unmount-on-close behaviour) each time it opens, so `editData`
// always seeds the initial state correctly.
const TravelTimeModal = ({ workOrderId, editData, handleClose, onSaved, disabled }) => {
  console.log(editData, "travel time editData");
  const isEdit = Boolean(editData?.id);

  const [travelDate, setTravelDate] = useState(
    editData?.travelDate ? fromUTC(editData.travelDate).dayjsObject : null,
  );
  const [travelhours, setTravelhours] = useState(editData?.travelhours || "");
  const [error, setError] = useState("");
  const [saving, setSaving] = useState(false);

  const validate = (value) => {
    try {
      travelSchema.validateSync({ travelhours: value }, { abortEarly: false });
      setError("");
      return true;
    } catch (err) {
      setError(err.errors[0]);
      return false;
    }
  };

  const handleSave = async () => {
    if (!travelDate) {
      toast.error("Please select travel date");
      return;
    }
    if (!validate(travelhours)) return;

    setSaving(true);
    const payload = {
      workOrderId,
      travelDate: toUTCWithStartOf(travelDate).utcISOString,
      travelhours,
    };
    const request = isEdit
      ? axiosPrivate.put(masterAPI["workOrder"].travelTimeUpdate, {
          id: editData.id,
          ...payload,
        })
      : axiosPrivate.post(masterAPI["workOrder"].travelTimeCreate, payload);

    await request
      .then(() => {
        // toast.success(`Travel time ${isEdit ? "updated" : "saved"} successfully`);
        onSaved();
        handleClose();
      })
      .catch((e) => {
        console.log(e, "error saving travel time");
        // toast.error(`Failed to ${isEdit ? "update" : "save"} travel time`);
      })
      .finally(() => setSaving(false));
  };

  return (
    <Grid container sx={{ p: 1 }} spacing={"1.5rem"}>
      <Grid item xs={12}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography
            sx={{
              color: color.masterDialogTitleColor,
              fontSize: "1.1rem",
              fontWeight: 500,
            }}
          >
            {isEdit ? "Edit Travelling Time" : "Add Travelling Time"}
          </Typography>
          <Box>
            <IconButton onClick={handleSave} disabled={saving || disabled}>
              {saving ? (
                <CircularProgress size={20} sx={{ color: "#2362B4" }} />
              ) : (
                <Save sx={{ color: "#2362B4" }} />
              )}
            </IconButton>
            <IconButton onClick={handleClose}>
              <Clear />
            </IconButton>
          </Box>
        </Box>
        <Divider sx={{ border: "1px solid rgb(0 0 0 / 17%)" }} />
      </Grid>

      <Grid item xs={12} md={6}>
        <Typography
          sx={{
            fontWeight: color.labelFontWeight,
            mb: color.labelmb,
            fontSize: color.labelFont,
          }}
        >
          Travel Date
        </Typography>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DemoItem>
            <DatePicker
              format="DD/MM/YYYY"
              readOnly={disabled}
              value={travelDate}
              maxDate={getCurrentInTimeZone().dayjsObject}
              slotProps={{
                textField: { size: "small", fullWidth: true },
              }}
              onChange={(newValue) => {
                if (newValue && `${newValue.$d}` !== "Invalid Date") {
                  setTravelDate(getDateWithOutUTC(newValue));
                }
              }}
              fullWidth
            />
          </DemoItem>
        </LocalizationProvider>
      </Grid>
      <Grid item xs={12} md={6}>
        <Typography
          sx={{
            fontWeight: color.labelFontWeight,
            mb: color.labelmb,
            fontSize: color.labelFont,
          }}
        >
          Travel Hours
        </Typography>
        <TextField
          fullWidth
          size="small"
          placeholder="HH:MM"
          value={travelhours}
          inputProps={{ readOnly: disabled }}
          onChange={(e) => {
            if (disabled) return;
            setTravelhours(e.target.value);
            validate(e.target.value);
          }}
          onBlur={(e) => {
            if (disabled) return;
            validate(e.target.value);
          }}
        />
        <ErrorProps>{error}</ErrorProps>
      </Grid>
    </Grid>
  );
};

export default TravelTimeModal;
